/**
 * Convert a number to Hebrew letters (gematria style) for display.
 * Uses geresh (') for single letter and gershayim (") before last letter for multiple.
 * Handles 15 and 16 as טו and טז to avoid spelling part of the divine name.
 */
export function numberToHebrewLetters(num: number): string {
  if (num <= 0 || num > 999) return String(num);

  const ones = ['', 'א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט'];
  const tens = ['', 'י', 'כ', 'ל', 'מ', 'נ', 'ס', 'ע', 'פ', 'צ'];
  const hundreds = ['', 'ק', 'ר', 'ש', 'ת', 'תק', 'תר', 'תש', 'תת', 'תתק'];

  let result = '';
  let n = num;

  if (n >= 100) {
    result += hundreds[Math.floor(n / 100)];
    n %= 100;
  }

  if (n === 15) {
    result += 'טו';
  } else if (n === 16) {
    result += 'טז';
  } else {
    if (n >= 10) {
      result += tens[Math.floor(n / 10)];
      n %= 10;
    }
    result += ones[n];
  }

  if (result.length === 1) {
    result += "'";
  } else if (result.length > 1) {
    result = result.slice(0, -1) + '"' + result.slice(-1);
  }

  return result;
}

/**
 * Format a number for display according to locale: Hebrew letters when lang is Hebrew, otherwise digits.
 */
export function formatNumberForLocale(num: number, lang: string): string {
  if (lang?.startsWith('he') || lang?.startsWith('iw')) {
    return numberToHebrewLetters(num);
  }
  return String(num);
}
